import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { BaseController } from '@shared/src/controllers/base.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { HomeController } from '../home/home.controller';
import { RoutePropertyDto } from '../route/properties/RoutePropertyDto';
import { RoutePropertyLogDto } from '../route/properties/RoutePropertyLogDto';
import { RoutePropertyChanged } from '../route/properties/RoutePropertyChanged';


@Injectable({
    providedIn: 'root',
})
export class OpenRoutePropertyController extends BaseController {

    private base = '/public/route'

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router,
        @Inject('HomeController') protected homeController: HomeController
    ) {
        super(http, alertService, translateService, loadingService, router);
    }


    //////////////////////DRIVER////////////////////
    public getDriverExistsPropertiesLinkedToSlotsPendingResponse(uuid: string, withalwaysask: boolean): Observable<boolean> {
        if(!withalwaysask)
            return this.get(this.base + '/driver/open/' + uuid + "/properties/linkedtoslots/pendingresponse/exists");
        return this.get(this.base + '/driver/open/' + uuid + "/properties/linkedtoslots/pendingresponse/existswithalwaysask");
    }

    public getDriverExistsPropertiesLinkedToSlots(uuid: string): Observable<boolean> {
        return this.get(this.base + "/driver/open/" + uuid + "/properties/linkedtoslots/exists");
    }

    public getDriverPropertiesByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/driver/open/" + uuid + "/properties");
    }

    public getDriverPropertiesLinkedToSlotsByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/driver/open/" + uuid + "/properties/linkedtoslots");
    }

    public getDriverPropertiesLinkedToSlotsPendingResponseByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/driver/open/" + uuid + "/properties/linkedtoslots/pendingresponse");
    }

    public getDriverRoutePropertyLogsByRoutePropertyId(uuid: string, routePropertyId: number): Observable<Array<RoutePropertyLogDto>> {
        return this.get(this.base + "/driver/open/" + uuid + "/properties/" + routePropertyId + "/logs");
    }

    public setDriverValue(uuid: string, rpDTO: RoutePropertyDto): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/driver/open/" + uuid + "/properties/setvalue", rpDTO, "setExworkValueList");
    }

    public setDriverValueList(uuid: string, rpDTOs: RoutePropertyDto[]): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/driver/open/" + uuid + "/properties/setvaluelist", rpDTOs, "setExworkValueList");
    }

    public setDriverValueListPhaseId(uuid: string, rpDTOs: RoutePropertyDto[], phaseId: number): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/driver/open/" + uuid + "/properties/setvaluelist/phaseId/" + phaseId, rpDTOs, "setExworkValueList");
    }

    public driverCompute(uuid: string): Observable<boolean> {
        return this.getBusy(this.base + "/driver/open/" + uuid + "/properties/compute");
    }

    //////////////////////EXWORK////////////////////
    public getExworkExistsPropertiesLinkedToSlotsPendingResponse(uuid: string, withalwaysask: boolean): Observable<boolean> {
        if(!withalwaysask)
            return this.get(this.base + "/exwork/open/" + uuid + "/properties/linkedtoslots/pendingresponse/exists");
        return this.get(this.base + "/exwork/open/" + uuid + "/properties/linkedtoslots/pendingresponse/existswithalwaysask");
    }

    public getExworkExistsPropertiesLinkedToSlots(uuid: string): Observable<boolean> {
        return this.get(this.base + "/exwork/open/" + uuid + "/properties/linkedtoslots/exists");
    }

    public getExworkPropertiesByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/exwork/open/" + uuid + "/properties");
    }

    public getExworkPropertiesLinkedToSlotsByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/exwork/open/" + uuid + "/properties/linkedtoslots");
    }

    public getExworkPropertiesLinkedToSlotsPendingResponseByRouteId(uuid: string): Observable<Array<RoutePropertyDto>> {
        return this.get(this.base + "/exwork/open/" + uuid + "/properties/linkedtoslots/pendingresponse");
    }

    public getExworkRoutePropertyLogsByRoutePropertyId(uuid: string, routePropertyId: number): Observable<Array<RoutePropertyLogDto>> {
        return this.get(this.base + "/exwork/open/" + uuid + "/properties/" + routePropertyId + "/logs");
    }

    public setExworkValue(uuid: string, rpDTO: RoutePropertyDto): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/exwork/open/" + uuid + "/properties/setvalue", rpDTO, "setExworkValueList");
    }

    public setExworkValueList(uuid: string, rpDTOs: RoutePropertyDto[]): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/exwork/open/" + uuid + "/properties/setvaluelist", rpDTOs, "setExworkValueList");
    }
    public setExworkValueListPhaseId(uuid: string, rpDTOs: RoutePropertyDto[], phaseId: number): Observable<RoutePropertyChanged> {
        return this.post(this.base + "/exwork/open/" + uuid + "/properties/setvaluelist/phaseId/" + phaseId, rpDTOs, "setExworkValueList");
    }

    public exworkCompute(uuid: string): Observable<RoutePropertyChanged> {
        return this.getBusy(this.base + "/exwork/open/" + uuid + "/properties/compute");
    }
}
